export const getRoleName = () => {
  return localStorage.getItem("roleName");
};

export const getPermissions = () => {
  const permissionData = localStorage.getItem("permission");
  try {
    return permissionData ? JSON.parse(permissionData) : [];
  } catch (err) {
    console.error("Invalid permission data:", err);
    return [];
  }
};

export const hasPermission = (moduleName) => {
  const roleName = getRoleName();
  const permissions = getPermissions();
  if (roleName === "Admin") return true;
  return permissions.some(p => p.module === moduleName && p.viewModule === true);
};

export const hasCreatePermission = (moduleName) => {
  const roleName = getRoleName();
  const permissions = getPermissions();
  if (roleName === "Admin") return true;
  return permissions.some(p => p.module === moduleName && p.createModule === true);
};


export const hasEditPermission = (moduleName) => {
  const roleName = getRoleName();
  const permissions = getPermissions();
  if (roleName === "Admin") return true;
  return permissions.some(p => p.module === moduleName && p.editModule === true);
};

export const hasViewPermission = (moduleName) => {
  const roleName = getRoleName();
  const permissions = getPermissions();
  if (roleName === "Admin") return true;
  return permissions.some(p => p.module === moduleName && p.viewModule === true);
};

export const hasdeletePermission = (moduleName) => {
  const roleName = getRoleName();
  const permissions = getPermissions();
  if (roleName === "Admin") return true;
  return permissions.some(p => p.module === moduleName && p.deleteModule === true);
};

export const hasSharePermission = (moduleName) => {
  const roleName = getRoleName();
  const permissions = getPermissions();
  if (roleName === "Admin") return true;
  return permissions.some(p => p.module === moduleName && p.shareModule === true);
};